import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  ICreateUpdateMetrics,
  IGetQueryParams,
  IZonesResponseObject,
} from "../../interfaces/Index";
import {
  createUpdateMetricsApiCall,
  fetchMetricsDetailsApiCall,
  getAllCoreMetricsAPICall,
  getCategoriesForMetrics,
  metricsCSVMultiPartUploadApiCall,
} from "redux/sources/MetricsSource";

export const createUpdateMetricsInit = () => ({
  type: actionTypes.CREATE_UPDATE_METRICS_INIT,
});

export const createUpdateMetricsSuccess = () => ({
  type: actionTypes.CREATE_UPDATE_METRICS_SUCCESS,
});

export const createUpdateMetricsFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_UPDATE_METRICS_FAIL,
  error,
});

export const getMetricsDetailsInit = () => ({
  type: actionTypes.GET_METRICS_DETAILS_INIT,
});

export const getMetricsDetailsSuccess = (
  payload: Array<ICreateUpdateMetrics>
) => ({
  type: actionTypes.GET_METRICS_DETAILS_SUCCESS,
  payload,
});

export const getMetricsDetailsFail = (error: string | object | null) => ({
  type: actionTypes.GET_METRICS_DETAILS_FAIL,
  error,
});

export const fetchAllCoreMetricsInit = () => ({
  type: actionTypes.GET_ALL_CORE_METRICS_INIT,
});

export const fetchAllCoreMetricsSuccess = (
  payload: IZonesResponseObject[] | null
) => ({
  type: actionTypes.GET_ALL_CORE_METRICS_SUCCESS,
  payload,
});

export const fetchAllCoreMetricsFail = (error: string | object | null) => ({
  type: actionTypes.GET_ALL_CORE_METRICS_FAIL,
  error,
});

export const getCategoriesForMetricsInit = () => ({
  type: actionTypes.GET_CATEGORIES_FOR_METRICS_INIT,
});

export const getCategoriesForMetricsSuccess = (payload: any) => ({
  type: actionTypes.GET_CATEGORIES_FOR_METRICS_SUCCESS,
  payload,
});

export const getCategoriesForMetricsFail = (error: string | object | null) => ({
  type: actionTypes.GET_CATEGORIES_FOR_METRICS_FAIL,
  error,
});

export const metricsUploadInit = () => ({
  type: actionTypes.METRICS_UPLOAD_INIT,
});

export const metricsUploadSuccess = () => ({
  type: actionTypes.METRICS_UPLOAD_SUCCESS,
});

export const metricsUploadFail = (error: string | object | null) => ({
  type: actionTypes.METRICS_UPLOAD_FAIL,
  error,
});

export const createUpdateMetrics =
  (payload: ICreateUpdateMetrics) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createUpdateMetricsInit());
    return createUpdateMetricsApiCall(payload)
      .then(() => dispatch(createUpdateMetricsSuccess()))
      .catch((e: object | null | string) =>
        dispatch(createUpdateMetricsFail(e))
      );
  };

export const getMetricsDetailsAction =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getMetricsDetailsInit());
    return fetchMetricsDetailsApiCall(id)
      .then((details: any) => dispatch(getMetricsDetailsSuccess(details)))
      .catch((e: object | null | string) => dispatch(getMetricsDetailsFail(e)));
  };

export const getAllCoreMetricsAction =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchAllCoreMetricsInit());
    return getAllCoreMetricsAPICall(queryParams)
      .then((data: any) => dispatch(fetchAllCoreMetricsSuccess(data)))
      .catch((e: object | null | string) =>
        dispatch(fetchAllCoreMetricsFail(e))
      );
  };

export const CategoriesForMetricsAction =
  (cityId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getCategoriesForMetricsInit());
    return getCategoriesForMetrics(cityId)
      .then((metricsCategories: any) =>
        dispatch(getCategoriesForMetricsSuccess(metricsCategories))
      )
      .catch((e: object | null | string) =>
        dispatch(getCategoriesForMetricsFail(e))
      );
  };

export const metricsUpload =
  (payload: FormData, queryParams?: IGetQueryParams) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(metricsUploadInit());
    return metricsCSVMultiPartUploadApiCall(payload, queryParams)
      .then(() => dispatch(metricsUploadSuccess()))
      .catch((e: object | null | string) => dispatch(metricsUploadFail(e)));
  };
